/* eslint-disable react/jsx-no-target-blank */
import React, { useCallback, useEffect, useState } from "react";
import PlayerCustom from "../components/PlayerCustom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import Sidebar from "../components/Slidebar";

export default function Home() {
  const [linkHome, setLinkHome] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [dataLive, setDataLive] = useState({});
  const [listLive, setListLive] = useState();
  const [listHot, setListHot] = useState();
  const [paging, setPaging] = useState({ current: 1, pageSize: 9 });
  const [isShowLoadMore, setIsShowLoadMore] = useState(false);
  const [urlPlayer, setUrlPlayer] = useState();
  const [liveDt, setLiveDt] = useState();
  const [tabLiveStream, setTabsLiveStream] = useState([]);
  const [activefilterLivesStream, setActiveFilterLivesStream] = useState("ALL");
  const [liveRoomHref, setLiveRoomHref] = useState("");

  useEffect(() => {
    fetchData();
    listDataLive(`?current=${paging.current}&pageSize=${paging.pageSize}`);
    fetchListHot();
    fetchTabsGetLivesStream();
  }, []);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      var myHeaders = new Headers();
      myHeaders.append("Cookie", "SERVER=api2");

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(
        "https://api-ls.cdnokvip.com/api/get-live-homepage",
        requestOptions
      );

      const data = await response.json();
      setDataLive(data?.value?.data);
      setUrlPlayer(data?.value?.data?.linkLive);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchListHot = async () => {
    setIsLoading(true);
    try {
      var myHeaders = new Headers();
      myHeaders.append("Cookie", "SERVER=api2");

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
      };
      const res = await fetch(
        "https://api-ls.cdnokvip.com/api/get-list-live-homepage",
        requestOptions
      );
      const data = await res.json();
      setListHot(data?.value?.data);
      setIsLoading(false);
    } catch (error) {
      console.log("error", error);
    }
  };

  const fetchTabsGetLivesStream = async () => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Cookie", "SERVER=api2");

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
      };
      const res = await fetch(
        "https://api-ls.cdnokvip.com/api/get-livestream_count",
        requestOptions
      );
      const data = await res.json();

      setTabsLiveStream(data?.value?.datas);
      setIsLoading(false);
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const listDataLive = async (query = "") => {
    setIsLoading(true);
    try {
      var myHeaders = new Headers();
      myHeaders.append("Cookie", "SERVER=api2");

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
      };
      const response = await fetch(
        `https://api-ls.cdnokvip.com/api/get-livestream-group${query}`,
        requestOptions
      );
      const data = await response.json();

      if (data?.value?.datas?.length) {
        setListLive(data?.value?.datas || []);
      }

      if (data?.value?.datas?.length === paging.pageSize) {
        setIsShowLoadMore(true);
      } else {
        setIsShowLoadMore(false);
      }
    } catch (error) {
      console.error("Error list live", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSeeMore = useCallback(async () => {
    const isActiveKeyValue = (param) => activefilterLivesStream === param;
    const query = `?current=${paging.current + 1}&pageSize=${
      paging.pageSize
    }&isHot=${isActiveKeyValue("HOT")}&isLive=${isActiveKeyValue(
      "LIVE"
    )}&isToday=${isActiveKeyValue("TODAY")}&isTomorrow=${isActiveKeyValue(
      "TOMORROW"
    )}`;

    try {
      var myHeaders = new Headers();
      myHeaders.append("Cookie", "SERVER=api2");
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
      };
      const response = await fetch(
        `https://api-ls.cdnokvip.com/api/get-livestream${query}`,
        requestOptions
      );
      const data = await response.json();

      if (data?.value?.datas?.length) {
        setListLive([...listLive, ...data?.value?.datas]);
      }

      if (
        // data?.value?.datas?.length === 0 ||
        // data?.value?.datas?.length > paging.pageSize
        data?.value?.datas?.length === paging.pageSize
      ) {
        setIsShowLoadMore(true);
        const _paging = {
          current: paging.current + 1,
          pageSize: paging.pageSize,
        };
        setPaging(_paging);
      } else {
        setIsShowLoadMore(false);
      }
    } catch (error) {
      console.error("Error list live", error);
    } finally {
      setIsLoading(false);
    }
  }, [activefilterLivesStream, listLive, paging]);

  useEffect(() => {
    if (dataLive?.matchId) {
      setLiveRoomHref(`/vao-phong-live/truc-tiep/${dataLive.matchId}`);
    }
  }, [dataLive]);

  const FormatNumber = ({ number }) => {
    const formattedNumber = (number / 1000).toString(); // Convert 130000 to 130
    return <span className="!tw-text-black">{formattedNumber}k</span>;
  };

  const formatCommentator = (name) => {
    // Loại bỏ các ký tự không cần thiết như dấu ngoặc
    const cleanedName = name.replace(/\(.*?\)/g, "").trim();

    // Split the name into parts
    const nameParts = cleanedName.split(" ");

    // Ignore the "BLV" prefix if it exists
    const filteredParts = nameParts.filter(
      (part) => part.toUpperCase() !== "BLV"
    );

    // Get the initials of the first name and the last name
    const initials = filteredParts[0][0].toUpperCase(); // First letter of the first name
    const lastName = filteredParts[filteredParts.length - 1].toUpperCase(); // Full last name

    return `${initials}.${lastName}`;
  };

  const calculateMatchTime = (halfStartTime) => {
    if (typeof halfStartTime !== "number" || halfStartTime <= 0) {
      return "00";
    }

    const now = Date.now(); // Current time in milliseconds
    const currentTimeInSeconds = Math.floor(now / 1000); // Convert to seconds

    const elapsedTime = currentTimeInSeconds - halfStartTime; // Calculate elapsed time in seconds

    const totalMinutes = Math.floor(elapsedTime / 60); // Convert to minutes

    // Ensure at least 2 digits
    return String(Math.max(totalMinutes, 0)).padStart(2, "0");
  };

  const formatMatchTime = (matchTime) => {
    if (typeof matchTime !== "number" || matchTime < 0) {
      throw new Error("Input must be a valid non-negative number");
    }

    // Convert to milliseconds for JavaScript Date
    const date = new Date(matchTime * 1000);

    // Adjust to GMT+7
    const hours = date.getUTCHours() + 7; // Add 7 hours for GMT+7
    const minutes = date.getUTCMinutes();

    // Handle overflow for hours
    const adjustedHours = hours % 24;

    // Format to hh:mm
    return `${String(adjustedHours).padStart(2, "0")}:${String(
      minutes
    ).padStart(2, "0")}`;
  };

  const images = [
    "https://res.cloudinary.com/dhssqbwnq/image/upload/v1737525492/kivpls8f7cvu9eiybxys.jpg",
    "https://res.cloudinary.com/dhssqbwnq/image/upload/v1737525491/ahsbp1qr88z2hrnsxyep.jpg",
    "https://res.cloudinary.com/dhssqbwnq/image/upload/v1737525492/htenyptm2kgmpl33jbjx.jpg",
    "https://res.cloudinary.com/dhssqbwnq/image/upload/v1737525490/mafhltnbyh86mwgyd8sr.jpg",
  ];

  return (
    <div className="!tw-mx-auto tw-bg-white">
      <div className="!tw-pt-0">
        {urlPlayer && (
          <div className="tw-flex">
            <Sidebar />
            <div className="tw-w-full tw-h-full tw-p-2 xl:tw-p-4">
              <div className="tw-flex tw-flex-col tw-gap-3 xl:tw-flex-row 2xl:tw-gap-4 tw-h-full tw-w-full">
                <div className="tw-relative tw-w-full xl:tw-w-3/4">
                  <PlayerCustom urlVideo={urlPlayer} />
                  <a
                    href={liveRoomHref}
                    rel="nofollow noopener"
                    target="_blank"
                    className="art-join-room"
                  >
                    Vào phòng live
                  </a>
                </div>
                <div className="tw-h-full xl:tw-hidden">
                  <Swiper
                    slidesPerView={3}
                    className="swiper-3d"
                    loop={true}
                    centeredSlides={true}
                  >
                    {images.map((img, index) => (
                      <SwiperSlide
                        key={index}
                        className="tw-flex tw-items-center tw-justify-center"
                      >
                        <img
                          src={img}
                          alt={`Slide ${index + 1}`}
                          className="tw-rounded-lg tw-object-cover"
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
                <div className="tw-hidden tw-w-full tw-flex-col tw-justify-between xl:tw-flex xl:tw-w-1/4">
                  <div className="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded tw-bg-[linear-gradient(90deg,_#FFDE29_0%,_#FFF17A_18.5%,_#FFDE29_38%,_#FFD852_58%,_#FFF17A_75.5%,_#FFDE29_88%,_#FE7_100%)] tw-p-2 2xl:tw-p-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M6.66745 7.63722C6.56057 8.77722 6.48557 10.7947 7.1587 11.6535C7.1587 11.6535 6.84182 9.43722 9.68245 6.6566C10.8262 5.53722 11.0906 4.01472 10.6912 2.87285C10.4643 2.22597 10.0499 1.6916 9.68995 1.31847C9.47995 1.0991 9.6412 0.737222 9.94682 0.750347C11.7956 0.832847 14.7918 1.3466 16.0649 4.5416C16.6237 5.9441 16.6649 7.39347 16.3987 8.86722C16.2299 9.80847 15.6299 11.901 16.9987 12.1578C17.9756 12.3416 18.4481 11.5653 18.6599 11.0066C18.7481 10.7741 19.0537 10.716 19.2187 10.9016C20.8687 12.7785 21.0093 14.9891 20.6681 16.8922C20.0081 20.571 16.2824 23.2485 12.5812 23.2485C7.95745 23.2485 4.27682 20.6028 3.32245 15.8141C2.93807 13.881 3.13307 10.056 6.11432 7.35597C6.33557 7.15347 6.69745 7.33347 6.66745 7.63722Z"
                        fill="url(#paint0_radial_654_37106)"
                      ></path>
                      <path
                        d="M14.2705 14.5165C12.5661 12.3227 13.3293 9.81958 13.7474 8.82208C13.8036 8.69083 13.6536 8.56708 13.5355 8.6477C12.8024 9.14645 11.3005 10.3202 10.6011 11.9721C9.65426 14.2052 9.72176 15.2983 10.2824 16.6333C10.6199 17.4377 10.228 17.6083 10.0311 17.6383C9.83988 17.6683 9.66363 17.5408 9.52301 17.4077C9.11853 17.0193 8.83026 16.5258 8.69051 15.9827C8.66051 15.8665 8.50863 15.8346 8.43926 15.9302C7.91426 16.6558 7.64238 17.8202 7.62926 18.6433C7.58801 21.1877 9.68988 23.2502 12.2324 23.2502C15.4368 23.2502 17.7711 19.7065 15.9299 16.744C15.3955 15.8815 14.893 15.3171 14.2705 14.5165Z"
                        fill="url(#paint1_radial_654_37106)"
                      ></path>
                      <defs>
                        <radialGradient
                          id="paint0_radial_654_37106"
                          cx="0"
                          cy="0"
                          r="1"
                          gradientUnits="userSpaceOnUse"
                          gradientTransform="translate(11.6654 23.3068) rotate(-179.751) scale(13.2352 21.7163)"
                        >
                          <stop offset="0.314" stop-color="#FF9800"></stop>
                          <stop offset="0.662" stop-color="#FF6D00"></stop>
                          <stop offset="0.972" stop-color="#F44336"></stop>
                        </radialGradient>
                        <radialGradient
                          id="paint1_radial_654_37106"
                          cx="0"
                          cy="0"
                          r="1"
                          gradientUnits="userSpaceOnUse"
                          gradientTransform="translate(12.4086 10.1362) rotate(90.5787) scale(13.8481 10.4217)"
                        >
                          <stop offset="0.214" stop-color="#FFF176"></stop>
                          <stop offset="0.328" stop-color="#FFF27D"></stop>
                          <stop offset="0.487" stop-color="#FFF48F"></stop>
                          <stop offset="0.672" stop-color="#FFF7AD"></stop>
                          <stop offset="0.793" stop-color="#FFF9C4"></stop>
                          <stop
                            offset="0.822"
                            stop-color="#FFF8BD"
                            stop-opacity="0.804"
                          ></stop>
                          <stop
                            offset="0.863"
                            stop-color="#FFF6AB"
                            stop-opacity="0.529"
                          ></stop>
                          <stop
                            offset="0.91"
                            stop-color="#FFF38D"
                            stop-opacity="0.209"
                          ></stop>
                          <stop
                            offset="0.941"
                            stop-color="#FFF176"
                            stop-opacity="0"
                          ></stop>
                        </radialGradient>
                      </defs>
                    </svg>
                    <span className="tw-font-bold tw-text-black xl:tw-text-sm 2xl:tw-text-base">
                      ƯU ĐÃI HOT NHẤT TẠI
                    </span>
                    <span className="tw-w-12 tw-rounded tw-bg-white tw-p-1 2xl:tw-w-16">
                      <img
                        src="https://res.cloudinary.com/dhssqbwnq/image/upload/v1737525694/okfnkcvv6bnlpl0ysrjv.png"
                        alt=""
                        className="tw-h-full tw-w-full tw-object-contain"
                      />
                    </span>
                  </div>
                  <div className="tw-hidden tw-h-[470px] tw-flex-col tw-gap-2 xl:tw-flex xl:tw-h-[450px] 2xl:tw-h-[620px] 4xl:tw-h-[890px]">
                    <Swiper
                      direction={"vertical"}
                      className="mySwiper"
                      slidesPerView={2}
                      spaceBetween={14}
                      loop={true}
                      autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                      }}
                    >
                      {images.map((imgItem, indexImg) => (
                        <SwiperSlide key={indexImg}>
                          <img src={imgItem} alt="" />
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </div>
              </div>
              <div className="tw-container tw-mt-4 2xl:tw-mt-8">
                <div className="tw-flex tw-w-full tw-flex-col tw-space-y-4 xl:tw-space-y-8 3xl:tw-w-[calc(100%-150px)]">
                  <div className="tw-w-full">
                    <div className="tw-mt-4 tw-grid tw-grid-cols-1 tw-gap-3 lg:tw-grid-cols-2 lg:tw-gap-6 2xl:tw-grid-cols-3 4xl:tw-grid-cols-4">
                      {listLive?.map((item, index) => (
                        <div
                          className="tw-w-full tw-rounded tw-border-2 tw-border-[#C0C2C5]"
                          key={index}
                        >
                          <a
                            href={`#/live/${item.matchId}`}
                            className="tw-flex tw-flex-col tw-gap-3 tw-rounded-t-sm tw-p-3 !tw-text-black"
                          >
                            <div className="tw-flex tw-justify-between">
                              <span className="tw-truncate tw-text-sm tw-font-medium">
                                {item?.leagueShortName || item?.leagueName}
                              </span>
                              {item.status > 0 ? (
                                <div className="tw-flex tw-gap-2">
                                  <div className="tw-flex tw-items-center tw-gap-0.5 tw-text-xs tw-font-medium xl:tw-text-sm">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="17"
                                      height="18"
                                      viewBox="0 0 17 18"
                                      fill="none"
                                    >
                                      <path
                                        d="M8.94765 15.7305C11.0735 15.3048 13.8224 13.7753 13.8224 9.82069C13.8224 6.22246 11.1885 3.8259 9.29448 2.72487C8.87352 2.48005 8.38183 2.80172 8.38183 3.28797V4.53113C8.38183 5.51179 7.96971 7.30172 6.82448 8.0464C6.23962 8.42655 5.60716 7.85734 5.53643 7.16367L5.47795 6.59377C5.40994 5.93139 4.73531 5.52947 4.20622 5.93343C3.25481 6.6577 2.26123 7.92942 2.26123 9.82001C2.26123 14.656 5.8581 15.8658 7.6562 15.8658C7.76138 15.8658 7.8711 15.8624 7.98535 15.8556C7.09719 15.7801 5.66157 15.2293 5.66157 13.4475C5.66157 12.0534 6.67826 11.1115 7.45082 10.6524C7.65892 10.53 7.90171 10.6898 7.90171 10.9312V11.3325C7.90171 11.6385 8.02072 12.118 8.30295 12.4457C8.62258 12.8171 9.09114 12.4281 9.12855 11.9398C9.14079 11.7861 9.29584 11.6882 9.42914 11.7657C9.86506 12.0207 10.422 12.5648 10.422 13.4475C10.422 14.8403 9.65424 15.4809 8.94765 15.7305Z"
                                        fill="#FFDE29"
                                      ></path>
                                    </svg>
                                    {<FormatNumber number={item.viewNumber} />}
                                  </div>
                                  <span className="tw-flex tw-items-center tw-justify-center tw-gap-0.5 tw-rounded tw-bg-[#f00000] tw-px-1 tw-py-0.5 tw-text-xs tw-font-medium tw-text-white">
                                    <img
                                      src="data:image/webp;base64,UklGRhACAABXRUJQVlA4WAoAAAASAAAAFwAAFwAAQU5JTQYAAAAAAAAAAABBTk1GPAAAAAAAAAAAABcAABcAADIAAAJWUDhMIwAAAC8XwAUQDzD/8z//8x/wUNC2DVNg5Y/sbggi+j8BsAyYvYQEAEFOTUY2AAAAAQAAAQAAEwAABwAAMgAAAlZQOEwdAAAALxPAARAPMP/zP//zH/AQkBAe+P9XNkT0fwJI8SQAQU5NRjQAAAABAAABAAATAAAFAAAyAAACVlA4TBwAAAAvE0ABEA8w//M///Mf8BCQEB74/1c2RPR/AoSTQU5NRjQAAAABAAABAAATAAAFAAAyAAACVlA4TBwAAAAvE0ABEA8w//M///Mf8BCQEB74/1c2RPR/Akg9QU5NRjQAAAABAAABAAATAAAHAAAyAAACVlA4TBsAAAAvE8ABEA8w//M///Mf8BAIJBnsLzxDRP9DpgUAQU5NRjYAAAABAAABAAATAAAHAAAyAAACVlA4TB0AAAAvE8ABEA8w//M///Mf8BCQEB74/1c2RPR/AmiPCQBBTk1GNAAAAAEAAAIAABMAAAUAADIAAAJWUDhMHAAAAC8TQAEQDzD/8z//8x/wEJAQHvj/VzZE9H8CaB1BTk1GNAAAAAEAAAIAABMAAAUAADIAAAJWUDhMHAAAAC8TQAEQDzD/8z//8x/wEJAQHvj/VzZE9H8CwNE="
                                      alt=""
                                      className="tw-h-3 tw-w-2.5 tw-object-contain"
                                    />
                                    <span>Live</span>
                                  </span>
                                </div>
                              ) : (
                                <div className="tw-flex tw-gap-2">
                                  <span className="tw-text-sm tw-font-medium">
                                    {formatMatchTime(item.matchTime)}
                                  </span>
                                </div>
                              )}
                            </div>

                            <div className="tw-flex tw-items-center tw-justify-between tw-gap-2">
                              <div className="tw-flex tw-w-2/5 tw-flex-col tw-items-center tw-justify-center">
                                <img
                                  className="tw-size-12 tw-rounded-full tw-bg-white tw-object-contain"
                                  src={item.homeLogo}
                                  alt=""
                                />
                                <p className="tw-mt-1 tw-w-full tw-truncate tw-text-center tw-font-medium !tw-text-black">
                                  {item.homeName}
                                </p>
                              </div>
                              {item.status > 0 ? (
                                <div className="tw-flex tw-w-1/5 tw-flex-col tw-items-center tw-justify-center">
                                  <span className="tw-truncate tw-text-lg tw-font-semibold tw-text-[#00BE23]">
                                    {calculateMatchTime(item.halfStartTime)}
                                    <span className="tw-animate-blink tw-ml-[2px]">
                                      '
                                    </span>
                                  </span>
                                  <span className="tw-mx-auto tw-w-full tw-whitespace-nowrap tw-rounded tw-bg-gradient-to-b tw-from-[#231ABD] tw-to-[#0A1D89] tw-py-1 tw-text-center tw-text-xl tw-font-semibold tw-text-white xl:tw-w-[80%]">
                                    0:1
                                  </span>
                                </div>
                              ) : (
                                <div className="tw-flex tw-w-1/5 tw-flex-col tw-items-center tw-justify-center">
                                  <span className="tw-mx-auto tw-w-full tw-whitespace-nowrap tw-rounded tw-bg-gradient-to-b tw-from-[#231ABD] tw-to-[#0A1D89] tw-py-1 tw-text-center tw-text-xl tw-font-semibold tw-text-white xl:tw-w-[80%]">
                                    VS
                                  </span>
                                </div>
                              )}

                              <div className="tw-flex tw-w-2/5 tw-flex-col tw-items-center tw-justify-center">
                                <img
                                  className="tw-size-12 tw-rounded-full tw-bg-white tw-object-contain"
                                  src={item.awayLogo}
                                  alt=""
                                />
                                <p className="tw-mt-1 tw-w-full tw-truncate tw-text-center tw-font-medium !tw-text-black">
                                  {item.awayName}
                                </p>
                              </div>
                            </div>
                          </a>

                          <div className="tw-rounded-b-sm tw-bg-gradient-to-b tw-from-[#ffffff] tw-to-[#FFFEED] tw-p-2">
                            <div className="tw-flex tw-w-full tw-items-center tw-gap-1">
                              <button className="!tw-inline-flex !tw-items-center !tw-justify-center !tw-gap-2 !tw-whitespace-nowrap !tw-rounded-md !tw-text-sm !tw-font-medium !tw-transition-colors !tw-focus-visible:tw-outline-none !tw-focus-visible:tw-ring-1 !tw-focus-visible:tw-ring-ring !tw-disabled:tw-pointer-events-none !tw-disabled:tw-opacity-50 [&_svg]:!tw-pointer-events-none [&_svg]:!tw-size-4 [&_svg]:!tw-shrink-0 !tw-border !tw-border-input !tw-bg-background !tw-shadow-sm hover:!tw-bg-accent hover:!tw-text-accent-foreground !tw-h-full !tw-w-7 !tw-p-3 swiper-blv-button-prev-349019520 !tw-text-black">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  className="lucide lucide-chevron-left"
                                >
                                  <path d="m15 18-6-6 6-6"></path>
                                </svg>
                              </button>
                              <Swiper
                                slidesPerView={Math.min(
                                  4,
                                  item.liveScoreRefs.length
                                )}
                                spaceBetween={30}
                                className="mySwiper1"
                                autoplay={{
                                  delay: 3000,
                                  disableOnInteraction: false,
                                }}
                              >
                                {item.liveScoreRefs.map(
                                  (commentator, indexCom) => (
                                    <SwiperSlide key={indexCom}>
                                      <a
                                        className="tw-flex tw-flex-col tw-items-center tw-justify-center"
                                        href={`#/live/${commentator.matchId}`}
                                      >
                                        <span className="tw-relative tw-flex shrink-0 tw-overflow-hidden tw-rounded-full tw-h-7 tw-w-7 border border-white">
                                          <img
                                            className="tw-aspect-square tw-h-full tw-w-full tw-object-cover"
                                            alt=""
                                            src={commentator.avatar}
                                          />
                                        </span>
                                        <span className="tw-mt-0.5 tw-truncate tw-text-xs tw-font-semibold !tw-text-black">
                                          {formatCommentator(
                                            commentator.commentator
                                          )}
                                        </span>
                                      </a>
                                    </SwiperSlide>
                                  )
                                )}
                              </Swiper>
                              <button className="!tw-inline-flex !tw-items-center !tw-justify-center !tw-gap-2 !tw-whitespace-nowrap !tw-rounded-md !tw-text-sm !tw-font-medium !tw-transition-colors !tw-focus-visible:tw-outline-none !tw-focus-visible:tw-ring-1 !tw-focus-visible:tw-ring-ring !tw-disabled:tw-pointer-events-none !tw-disabled:tw-opacity-50 [&_svg]:!tw-pointer-events-none [&_svg]:!tw-size-4 [&_svg]:!tw-shrink-0 !tw-border !tw-border-input !tw-bg-background !tw-shadow-sm hover:!tw-bg-accent hover:!tw-text-accent-foreground !tw-h-full !tw-w-7 !tw-p-3 swiper-blv-button-next-349019520 !tw-text-black">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  className="lucide lucide-chevron-right"
                                >
                                  <path d="m9 18 6-6-6-6"></path>
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
